<!-- @format -->

<div class="approvals-container">
  <div class="row m-0 btm-row">
    <!-- approvals -->
    @if (isApprovals === true) {
      <div class="lhs p-0" [class.approvals]="isApprovals">
        <div class="select-title border-btm top-row">
          <h4>Quick Select:</h4>
          <div class="row d-flex justify-content-between btn-container mx-0">
            <button class="btn btn-link quick-link" (click)="toggleAll(true)" [class.selected]="quickSelect === 'all'">All</button>
            <button class="btn btn-link quick-link" (click)="selectCurrentWeek()" [class.selected]="quickSelect === 'week'">
              Current Week
            </button>
            <button class="btn btn-link quick-link" (click)="toggleAll(false)" [class.selected]="quickSelect === 'none'">None</button>
          </div>
        </div>
        <!-- team list-->
        @if (showTeamMembers()) {
          <div [formGroup]="selectForm" class="p-0">
            <div formArrayName="apprEmps">
              @for (ctrl of appArr.controls; track ctrl; let i = $index) {
                <div [formGroupName]="i">
                  @if (showWeekTitle(i)) {
                    <div class="week-title">
                      {{emailDateMap[i].week}}
                    </div>
                  }
                  @if (currentWeekStr === emailDateMap[i].week && showWeekTitle(i)) {
                    <div class="deadline border-top mb-2">
                      <i class="fa-light fa-hourglass-half fa-xl"></i>
                      <strong>Deadline to submit:</strong>&nbsp;{{deadlineDate | date: 'MMMM d'}} at 3:00pm
                    </div>
                  }
                  <div class="employee border-btm" [class.selected]="isSelected(i)" [class.border-top-2px]="showWeekTitle(i)">
                    <div class="d-flex justify-content-space">
                      <label class="container d-flex">
                        <div class="img">
                          <img class="profile_icon" [src]="getMemberProfilePic(emailDateMap[i].email)" />
                        </div>
                        <div
                          class="employeeName"
                          [class.invalidTs]="getApprovalsMemberStatus(emailDateMap[i].email, emailDateMap[i].startDate) === 'invalid'">
                          {{getTeamMemberName(emailDateMap[i].email)}}
                        </div>
                        <input type="checkbox" formControlName="chkbox" (change)="onChkboxChange($event, i)" />
                        <span class="checkmark"></span>
                      </label>
                      <div
                        class="status {{getApprovalsMemberStatus(emailDateMap[i].email, emailDateMap[i].startDate)}}"
                        title="{{getStatusText(getApprovalsMemberStatus(emailDateMap[i].email, emailDateMap[i].startDate))}}">
                        <i class="fa-regular fa-clock"></i>
                        <i class="fa-solid fa-circle-x"></i>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- {{emailDateMap | json}} -->
            </div>
          </div>
        }
      </div>
    }
    <!--- team -->
    @if (!isApprovals) {
      <div class="lhs p-0">
        <!-- calendar-->
        <div class="row top-row m-0 border-btm">
          <h4>Select a week</h4>
          <div class="input-group">
            <div [formGroup]="dpForm" class="control-wrapper">
              <input
                class="form-control invisible p-0"
                placeholder="yyyy-mm-dd"
                name="dp"
                ngbDatepicker
                #d="ngbDatepicker"
                [firstDayOfWeek]="6"
                [dayTemplate]="customDay"
                [weekdays]="'short'"
                [minDate]="minDate"
                [placement]="'bottom-start'"
                [navigation]="'arrows'"
                (dateSelect)="onDateSelect($event)" />
              <input class="form-control" type="text" formControlName="weekRange" (click)="d.toggle(); " placeholder="selected week" />
              <ng-template #customDay let-date let-currentMonth="currentMonth">
                <span
                  [class.shade]="shouldDarkenEntryBG(date)"
                  [class.outsideMonth]="date.month !== currentMonth"
                  [class.range]="isRange(date)">
                  <span [class.today]="isToday(date)">
                    {{ date.day }}
                  </span>
                </span>
              </ng-template>
            </div>
            <button class="btn btn-outline-secondary" (click)="d.toggle();" type="button"><i class="fa-regular fa-calendar"></i></button>
          </div>
        </div>
        <!-- filter by status-->
        <div class="row m-0 top-row border-btm filter">
          <h4>Filter by status:</h4>
          <div class="row d-flex justify-content-between btn-container">
            <button
              class="btn btn-link"
              [class.filterToggled]="getIsFilterToggled('saved,predicted')"
              (click)="filterByStatus('saved,predicted')"
              title="Not Submitted">
              <span class="fa-stack" style="vertical-align: top;">
                <i class="fa-regular fa-circle fa-stack-2x"></i>
                <i class="fa-sharp fa-solid fa-question fa-stack-1x"></i>
              </span>
              <span class="count">({{statusCount.pending}})</span>
            </button>
            <button
              class="btn btn-link"
              [class.filterToggled]="getIsFilterToggled('invalid')"
              (click)="filterByStatus('invalid')"
              title="Invalid timesheet">
              <i class="fa-solid fa-circle-x"></i><br />
              <span class="count">({{statusCount.invalid}})</span>
            </button>
            <button
              class="btn btn-link"
              [class.filterToggled]="getIsFilterToggled('submitted')"
              (click)="filterByStatus('submitted')"
              title="Pending approval">
              <i class="fa-regular fa-clock"></i><br />
              <span class="count">({{statusCount.submitted}})</span>
            </button>
            <button
              class="btn btn-link"
              [class.filterToggled]="getIsFilterToggled('approved')"
              (click)="filterByStatus('approved')"
              title="Approved">
              <i class="fa-sharp fa-solid fa-circle-check"></i><br />
              <span class="count">({{statusCount.approved}})</span>
            </button>
            <button
              class="btn btn-link"
              [class.filterToggled]="getIsFilterToggled('jde')"
              (click)="filterByStatus('jde')"
              title="Sent to JDE">
              <i class="fa-regular fa-circle-arrow-right"></i><br />
              <span class="count">({{statusCount.jde}})</span>
            </button>
            <!-- <button class="btn btn-link" (click)="filterByStatus('overdue')"><i
          class="fa-solid fa-circle-exclamation"></i></button> -->
          <!-- <button class="btn btn-link" (click)="filterByStatus('')" title="show all">None</button> -->
        </div>
      </div>
      <!-- team list-->
      @if (showTeamMembers()) {
        <div class="row m-0">
          <div class="select-text border-btm">Select a team member:</div>
          <div [formGroup]="teamForm" class="p-0">
            @for (tp of teamProfileFiltered; track tp; let i = $index) {
              <div
                class="d-flex justify-content-between employee border-btm team"
                [class.selected]="selectedEmployees === tp.email"
                [class.d-none]="filterAction(tp.status!)">
                <label class="container d-flex">
                  @if (tp.profilePic) {
                    <div class="img">
                      <img class="profile_icon" [src]="tp.profilePic" />
                    </div>
                  }
                  <div class="employeeName" [class.invalidTs]="tp.status === 'invalid'">{{getTeamMemberName(tp.email)}}</div>
                  <input
                    type="radio"
                    formControlName="employees"
                    [value]="tp.email"
                    id="{{tp.email}}"
                    name="employees"
                    class="d-none"
                    (click)="onRdoClick(tp.email)" />
                </label>
                <div class="status {{tp.status}}" title="{{getStatusText(tp.status)}}">
                  <i class="fa-regular fa-clock"></i>
                  <i class="fa-solid fa-circle-x"></i>
                  <i class="fa-sharp fa-solid fa-circle-check"></i>
                  <i class="fa-regular fa-circle-arrow-right"></i>
                  <span class="fa-stack" style="vertical-align: top;">
                    <i class="fa-regular fa-circle fa-stack-2x"></i>
                    <i class="fa-sharp fa-solid fa-question fa-stack-1x"></i>
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }

  <div class="rhs p-0" [class.approvals]="isApprovals">
    <div
      class="d-flex top-row m-0 border-btm week-range border-left"
      [class.justify-content-end]="isApprovals"
      [class.justify-content-between]="!isApprovals">
      @if (!isApprovals) {
        <div class="dateBar">
          <div class="pl-2 current-week">
            <h2>{{currentWeekStr}}</h2>
          </div>
          <div class="payPeriodWeek">{{payperiodWeek}}</div>
        </div>
      }
      @if (isShowingMultipleTimesheets) {
        <div class="p-2 d-flex align-items-center">
          <button (click)="approveTimesheets()" class="float-right btn btn-primary submit-btn">Approve all</button>
        </div>
      }
    </div>
    @if (!isApprovals) {
      <div class="deadline m-0 border-left d-flex justify-content-start" [class.teams]="!isApprovals">
        <i class="fa-light fa-hourglass-half fa-xl"></i>
        <strong>Deadline to submit:</strong>&nbsp;{{deadlineDate | date: 'MMMM d'}} at 3:00pm
      </div>
    }
    @if (!isApprovals) {
      <div class="btm-row entries m-0 border-left">
        @for (submission of filteredTimesheets; track submission) {
          @for (timesheet of submission.timesheets; track timesheet) {
            <div class="border-btm-thin entry pb-3">
              @if (isApprovals && currentWeek.startDate.getTime() === timesheet.startDate.getTime()) {
                <div
                  class="deadline m-0 border d-flex justify-content-start"
                  >
                  <i class="fa-light fa-hourglass-half fa-xl"></i>
                  <strong>Deadline to submit:</strong>&nbsp;{{deadlineDate | date: 'MMMM d'}} at 3:00pm
                </div>
              }
              <div class="employee-name">
                {{ getTeamMemberName(submission.employeeEmail) }}
                <!-- <ng-container *ngIf="timekeeperView">
                <div class="userDisplayedInfo">
                  <span class="managerName">Manager: {{getUserManager(submission.employeeEmail)}}</span>
                </div>
              </ng-container> -->
              <div class="userDisplayedInfo">
                @if (!getUserIsManagerTeamMember(submission.employeeEmail)) {
                  <span class="managerName">
                    Manager: {{getUserManager(submission.employeeEmail)}}
                  </span>
                }
                <span class="cdoDetails">CDO: {{getUserCdo(submission, timesheet)}}</span>
              </div>
            </div>
            <div class="submission-details">
              <div class="col">
                @if (timesheet.status === 'Submitted') {
                  <div class="employee-submit-date">
                    Submitted on {{timesheet.submittedDateTime | date:'MMMM d '}} at
                    {{timesheet.submittedDateTime |
                    date:'
                    h:mm aa'}}
                  </div>
                }
                @if (timesheet.status === 'Approved') {
                  <div class="employee-submit-date">
                    Approved on {{timesheet.approvedDateTime | date:'MMMM d '}} at {{timesheet.approvedDateTime | date:'h:mm aa'}}
                  </div>
                }
                @if (timesheet.status === 'Saved' || timesheet.status === 'Predicted') {
                  <div class="employee-submit-date">
                    This timesheet hasn't been submitted yet@if (isOverDue()) {
                    <span> and is overdue</span>
                    }.
                  </div>
                }
              </div>
              @if (!timekeeperView || (isTimekeeperAndManager && getIsTimesheetAllowedToApprove(timesheet))) {
                <div
                  class="col d-flex justify-content-end">
                  <button class="edit-btn" (click)="openTimesheetEditModal(submission.employeeEmail, timesheet)">
                    Edit<i class="fa-solid fa-pencil"></i>
                  </button>
                </div>
              }
            </div>
            <app-entry-form
              [selectedTimesheet]="timesheet"
              [isApprovalsView]="true"
              [currentConfiguration]="getRelativeConfiguration(timesheet)"
              [editOverride]="true"
              [timeEntryTypes]="getTimeEntryTypes(timesheet)"
              [exceptionTypes]="exceptionTypes"
              [weekOneTsHasUsedCdo]="getWeekOneTsHasUsedCdo(timesheet, submission.employeeEmail)"
            (needsToBlockApprovals)="updateApprovalLockStatus($event, timesheet)"></app-entry-form>
            @if (timesheet.status === 'Submitted' && (!timekeeperView || (isTimekeeperAndManager && getIsTimesheetAllowedToApprove(timesheet)))) {
              <div
                class="d-flex justify-content-end approval-btns">
                <!-- <ng-container>
                <button type="button" class="btn btn-outline-primary add-btn mx-2">Return to team
                member</button>
              </ng-container> -->
              <ng-container>
                <button
                  type="submit"
                  class="btn btn-primary submit-btn"
                  [disabled]="getIsTimesheetApprovalLocked(timesheet)"
                  (click)="approveTimesheet(submission, timesheet)">
                  Approve
                </button>
              </ng-container>
            </div>
          }
          @if ((timesheet.status === 'Saved' || timesheet.status === 'Predicted') && (!timekeeperView || (isTimekeeperAndManager && getIsTimesheetAllowedToApprove(timesheet)))) {
            <div
              class="d-flex justify-content-end approval-btns">
              <ng-container>
                <button
                  type="submit"
                  class="btn btn-primary submit-btn"
                  [disabled]="getIsTimesheetApprovalLocked(timesheet)"
                  (click)="approveTimesheet(submission, timesheet)">
                  Submit and approve
                </button>
              </ng-container>
            </div>
          }
        </div>
      }
    }
    @if (filteredTimesheets.length > 0) {
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-link" (click)="scrollToTop()">top</button>
      </div>
    }
  </div>
}
<!-- timesheets grouped by week-->
@if (isApprovals) {
  <div class="btm-row entries m-0 border-left">
    @for (week of sortedByWeek; track week) {
      @for (user of week.user; track user; let i = $index) {
        @if (getTimesheetByStartDate(week.startDate, user); as timesheet) {
          <div>
            <div class="entry pb-3" [class.border-btm-thin]="i+1 === week.user.length">
              <div class="dateBar">
                <div class="current-week">
                  @if (i === 0) {
                    <h2>
                      {{dateToString(dateToNgbDate(timesheet.startDate),
                      dateToNgbDate(timesheet.endDate))}}
                    </h2>
                  }
                </div>
                @if (i === 0) {
                  <div class="payPeriodWeek">{{ getTimesheetPayPeriodInfo(timesheet) }}</div>
                }
              </div>
              @if (isApprovals && currentWeek.startDate.getTime() === timesheet.startDate.getTime() && i === 0) {
                <div
                  class="deadline m-0 border d-flex justify-content-start"
                  >
                  <i class="fa-light fa-hourglass-half fa-xl"></i>
                  <strong>Deadline to submit:</strong>&nbsp;{{deadlineDate | date: 'MMMM d'}} at 3:00pm
                </div>
              }
              <div class="employee-name">
                {{ getTeamMemberName(user) }}
                <div class="userDisplayedInfo">
                  @if (!getUserIsManagerTeamMember(user)) {
                    <span class="managerName"> Manager: {{getUserManager(user)}} </span>
                  }
                  <span class="cdoDetails">CDO: {{getUserCdo(null, timesheet, user)}}</span>
                </div>
              </div>
              <div class="submission-details">
                <div class="col">
                  @if (timesheet.status === 'Submitted') {
                    <div class="employee-submit-date">
                      Submitted on
                      {{timesheet.submittedDateTime | date:'MMMM d '}} at
                      {{timesheet.submittedDateTime |
                      date:'
                      h:mm aa'}}
                    </div>
                  }
                  @if (timesheet.status === 'Approved') {
                    <div class="employee-submit-date">
                      Approved on {{timesheet.approvedDateTime | date:'MMMM d '}} at
                      {{timesheet.approvedDateTime | date:'h:mm aa'}}
                    </div>
                  }
                  @if (timesheet.status === 'Saved' || timesheet.status === 'Predicted') {
                    <div class="employee-submit-date">
                      This timesheet hasn't been submitted yet and is overdue.
                    </div>
                  }
                </div>
                <div class="col d-flex justify-content-end">
                  <button class="edit-btn" (click)="openTimesheetEditModal(user, timesheet)">
                    Edit<i class="fa-solid fa-pencil"></i>
                  </button>
                </div>
              </div>
              <app-entry-form
                [selectedTimesheet]="timesheet"
                [isApprovalsView]="true"
                [currentConfiguration]="getRelativeConfiguration(timesheet)"
                [editOverride]="true"
                [timeEntryTypes]="getTimeEntryTypes(timesheet)"
                [exceptionTypes]="exceptionTypes"
                [weekOneTsHasUsedCdo]="getWeekOneTsHasUsedCdo(timesheet, user)"
              (needsToBlockApprovals)="updateApprovalLockStatus($event, timesheet)"></app-entry-form>
              @if (timesheet.status === 'Submitted' && (!timekeeperView || (isTimekeeperAndManager && getIsTimesheetAllowedToApprove(timesheet)))) {
                <div
                  class="d-flex justify-content-end approval-btns">
                  <ng-container>
                    <button
                      type="submit"
                      class="btn btn-primary submit-btn"
                      [disabled]="getIsTimesheetApprovalLocked(timesheet)"
                      (click)="prepApproveTimesheet(user, timesheet)">
                      Approve
                    </button>
                  </ng-container>
                </div>
              }
              @if (timesheet.status === 'Saved' || timesheet.status === 'Predicted') {
                <div
                  class="d-flex justify-content-end approval-btns">
                  <ng-container>
                    <button
                      type="submit"
                      class="btn btn-primary submit-btn"
                      [disabled]="getIsTimesheetApprovalLocked(timesheet)"
                      (click)="prepApproveTimesheet(user, timesheet)">
                      Submit
                    </button>
                  </ng-container>
                </div>
              }
            </div>
          </div>
        }
      }
    }
    @if (filteredTimesheets.length > 0) {
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-link" (click)="scrollToTop()">top</button>
      </div>
    }
  </div>
}
</div>
</div>
</div>
